module.exports = __webpack_public_path__ + "static/media/mangaa.7155e156.png";